export default '/page/*'
